module.exports = __webpack_public_path__ + "static/search1-8b977ce9189b0268d548fed28796c4b5.png";